export default __webpack_public_path__ + "static/Atlanta-968449f9a8731a53d2333329af1143df.png";